class AdvisorBlockedSuggestion {
  constructor(private $state: ng.ui.IStateService) {}
  navigateToBlockedSuggestion() {
    this.$state.go(`ap-advisor.retain_suggestions.blocked_suggestions`);
  }
}

angular.module('capability-ng-academic-planner').component('backToBlockedSuggestions', {
  templateUrl:
    'capability-ng-academic-planner/src/suggestions/components/blocked_suggestions/components/back_to_blocked_suggestions/back_to_blocked_suggestions.html',
  controller: AdvisorBlockedSuggestion
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/blocked_suggestions/components/back_to_blocked_suggestions/back_to_blocked_suggestions.ts